<div class="row">
    <div class="col-md-12">

        <nav class="nav nav-pills nav-fill">
            <a class="nav-link active" data-toggle="pill" data-target="#pills-beneficios" type="button" role="tab"
                aria-controls="pills-beneficios" aria-selected="true">Beneficios</a>
            <a class="nav-link" data-toggle="pill" data-target="#pills-sponsors" type="button" role="tab"
                aria-controls="pills-sponsors" aria-selected="false">Patrocinadores</a>
        </nav>
        <div class="tab-content" id="pills-tabContent">
            <!-- Beneficios -->
            <div class="tab-pane fade show active" id="pills-beneficios" role="tabpanel" aria-labelledby="pills-beneficios-tab">
                <div class="cardBloque ">
                    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">BENEFICIOS</h1>
                
                
                    <div class="row" *ngIf="this.beneffits.length > 0 ">
                        <div class="col-md-3" *ngFor="let bene of paginatedBeneffits">
                            <ng-container *ngIf="bene.link">
                                <div class="card colorLandingCard" (click)="redirectInmoapp()" style="cursor: pointer;">
                                    <div class="card-body">
                                        <div class="containTextBenTitle">
                                            <h2 class="text-center text-primary">{{bene.title}}</h2>
                                        </div>
                                        <img class="img-responsiva  img-fluid " [src]="url + bene.image" alt="banner">
                                        <div class="containTextBen">
                                            <p class="card-text mt-2  ">
                                                {{bene.description}}
                                            </p>
                                        </div>
                
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!bene.link">
                                <div class="card colorLandingCard">
                                    <div class="card-body">
                                        <div class="containTextBenTitle">
                                            <h2 class="text-center text-primary">{{bene.title}}</h2>
                                        </div>
                                        <div *ngIf="bene.category_name" class="text-center">
                                            <span class="badge badge-pill badge-primary">{{bene.category_name}} </span>
                                        </div>
                                        <img class="img-responsiva  img-fluid " [src]="url + bene.image" alt="banner">
                                        <div class="containTextBen">
                                            <p class="card-text mt-2 ">
                                                {{bene.description}}
                                            </p>
                                        </div>
                
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 text-center">
                            <button class="btn btn-primary" (click)="goToPage(currentPage - 1)"
                                [disabled]="currentPage === 1">Anterior</button>
                        </div>
                        <div class="col-md-6 text-center">
                            <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                                [disabled]="currentPage * pageSize >= beneffits.length">Siguiente</button>
                        </div>
                    </div>
                
                    <div class="text-center">
                        <a href="/beneficios" class="btn btn-primary">+</a>
                    </div>
                </div>
            </div>
            <!-- Patrocinadores -->
            <div class="tab-pane fade" id="pills-sponsors" role="tabpanel" aria-labelledby="pills-sponsors-tab">
                <div class="cardBloque ">
                    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">Patrocinadores</h1>
                
                    <div class="row">
                        <div class="col-md-4 col-12 mb-1">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Buscar" aria-describedby="button-addon2"
                                    style="border-radius:20px 0px 0px 20px;" [(ngModel)]="search" />
                                <div class="input-group-append" id="button-addon2">
                                    <button type="button" class="btn btn-icon btn-outline-primary"
                                        style="border-radius:0px 20px 20px 0px;" rippleEffect (click)="searchSponsors()">
                                        <span [data-feather]="'search'"></span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                
                
                    <div class="row" *ngIf="sponsors.length > 0 ">
                        <div class="col-md-3" *ngFor="let bene of paginatedSponsors">
                            <ng-container>
                                <div class="card colorLandingCard" style="cursor: pointer;">
                                    <div class="card-body">
                                        <div class="containTextBenTitle">
                                            <h2 class="text-center text-primary">{{bene.name}}</h2>
                                        </div>
                                        <div>
                                            <img class="img-responsiva  img-fluid " [src]="url + bene.logo" alt="banner"
                                                [ngStyle]="{'cursor':bene.url_web?'pointer':''}" (click)="sendWebPage(bene.url_web)">
                                        </div>

                                        
                                        <div class="containTextBen">
                                            <p class="card-text mt-1 ">
                                                Ubicación: {{bene.street+', #'+bene.noExt}}
                                                <br>
                                                Teléfono: {{bene.phone | slice:0:3
                                                }}-{{bene.phone | slice:3:6
                                                }}-{{bene.phone |
                                                slice:6:10 }}
                                                <br>
                                                Email: {{bene.email}}
                                            </p>
                                        </div>
                
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 text-center">
                            <button class="btn btn-primary" (click)="goToPage(currentPage - 1)"
                                [disabled]="currentPage === 1">Anterior</button>
                        </div>
                        <div class="col-md-6 text-center">
                            <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                                [disabled]="currentPage * pageSize >= sponsors.length">Siguiente</button>
                        </div>
                    </div>
                    <ng-container *ngIf="sponsors.length == 0 && bandShow">
                        <h3 class="mt-1 text-center">No hay resultados</h3>
                    </ng-container>
                    <!-- <div class="row mt-5">
                        <div class="col-md-12 text-center">
                            <a href="/socios" class="btn btn-primary">Ver Mas...</a>
                        </div>
                    </div> -->
                
                
                
                </div>
            </div>
           
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
    </div>
</div>